import { render, staticRenderFns } from "./scoreDialog.vue?vue&type=template&id=7c68d744&scoped=true"
import script from "./scoreDialog.vue?vue&type=script&lang=js"
export * from "./scoreDialog.vue?vue&type=script&lang=js"
import style0 from "./scoreDialog.vue?vue&type=style&index=0&id=7c68d744&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c68d744",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c68d744')) {
      api.createRecord('7c68d744', component.options)
    } else {
      api.reload('7c68d744', component.options)
    }
    module.hot.accept("./scoreDialog.vue?vue&type=template&id=7c68d744&scoped=true", function () {
      api.rerender('7c68d744', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/assessment/components/scoreDialog.vue"
export default component.exports